<script>
    import { onMount, tick } from "svelte";
    import Chart from 'chart.js/auto';
    import chartService from '../../../services/chart.js';
    import { format } from "svelte-i18n";

    let { findingCount = {} } = $props();

    let canvas     = $state();
    let totals     = $state({});
    let severities = ["critical", "high", "medium", "low"];
    let labels     = {
        critical: $format("vulnerability.severity.critical"),
        high: $format("vulnerability.severity.high"),
        medium: $format("vulnerability.severity.medium"),
        low: $format("vulnerability.severity.low")
    };
    let chart;

    onMount(async () => {
        await tick();

        let context  = canvas.getContext('2d');

        let chartData = {
            labels   : [],
            datasets : {
                backgroundColor : [chartService.colors.critical, chartService.colors.high, chartService.colors.medium, chartService.colors.low],
                data: [],
            },
        }

        for (const s of severities) {
            totals[s] = findingCount[s];
        }

        for (const [k, v] of Object.entries(totals)) {
            if(totals.critical > 0 || totals.high > 0 || totals.medium > 0 || totals.low > 0){
                chartData.labels.push(labels[k]);
                chartData.datasets.data.push(v);
            }
        }

        chart   = new Chart(context, {
            type: 'doughnut',
            options: {
                // Elements options apply to all of the options unless overridden in a dataset
                // In this case, we are setting the border of each horizontal bar to be 2px wide

                //clip: false,
                responsive: true,
                maintainAspectRatio: false,
                borderWidth     : 1,
                //cutout: '50%',
                weight : 20,
                plugins:{
                    legend: {
                        position: 'right',
                        labels: {
                            font: {
                                fontFamily: 'Montserrat',
                                size: 14
                            }
                        }
                    },
                },
                title: {
                    display: false,
                },
                animation : {
                    animateScale: true,
                    animateRotate: true
                },
                onHover : (event) => {
                    canvas.style.cursor = "pointer";
                },
                onClick: (event)=> {
                    let severity = Object.keys(labels).filter(k=>labels[k] == event.chart.tooltip.title[0])[0];
                    window.location.href = `/finding?vulnerability__level__in=${severity}`
                }
            },
            data : {
                labels  : chartData.labels,
                datasets: [chartData.datasets]
            },
        });
    });
</script>
<style>
    /*#chart-vuls-by-severity {
        height: 250px !important;
        margin: 0 auto;
        width: 808px;
    }*/
</style>
<canvas bind:this={canvas} id="chart-vuls-by-severity" class:chart-has-no-data="{totals["critical"] == 0 && totals["high"] == 0 && totals["medium"] == 0 && totals["low"] == 0}" ></canvas>
